import React from 'react';
import { Helmet } from 'react-helmet-async';
import { MailIcon } from 'lucide-react';
export function LeadershipPage() {
  const leaders = [{
    name: 'H. GT. Denny Ramdhani, S.H.',
    title: 'Director',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7qHA5xTLqzhhJbzjaRyUa8/HGT.png',
    profile: ['H. GT. Denny Ramdhani, S.H. memimpin PT. Jagat Indo Perkasa dengan visi untuk menjadikan perusahaan sebagai penyedia layanan ground handling terkemuka di Indonesia.', 'Dengan pengalaman luas di industri penerbangan dan komitmen terhadap keunggulan operasional, beliau membawa profesionalisme dan inovasi dalam setiap aspek bisnis perusahaan.', 'Di bawah kepemimpinannya, PT. Jagat Indo Perkasa terus berkembang dan memperluas jangkauan layanan ke berbagai bandara strategis di Indonesia, dengan fokus pada keselamatan, efisiensi, dan kepuasan pelanggan.']
  }, {
    name: 'Rano, S.H.',
    title: 'General Manager',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gdoVs259iQdGvRJ3yzsVM9/GM.png',
    profile: ['Rano, S.H. sebagai General Manager bertanggung jawab atas operasional harian perusahaan dan memastikan semua layanan ground handling berjalan dengan standar tertinggi.', 'Dengan pengalaman mendalam dalam manajemen operasional penerbangan, beliau memimpin tim untuk memberikan layanan yang efisien dan andal di setiap bandara operasional.', 'Komitmen beliau terhadap keunggulan operasional dan kepuasan pelanggan menjadi kunci kesuksesan PT. Jagat Indo Perkasa dalam industri ground handling.']
  }];
  return <div className="w-full" data-id="element-380">
      <Helmet data-id="element-381">
        <title data-id="element-382">
          Pimpinan - PT Jagat Indo Perkasa | H. GT. Denny Ramdhani (Director) &
          Rano (GM)
        </title>
        <meta name="description" content="Kepemimpinan PT Jagat Indo Perkasa: H. GT. Denny Ramdhani, S.H. sebagai Director dengan visi keunggulan ground handling, dan Rano, S.H. sebagai General Manager dengan pengalaman operasional mendalam. Tim manajemen berpengalaman dengan dedikasi pada keselamatan, efisiensi, dan kepuasan pelanggan dalam industri ground handling Indonesia." data-id="element-383" />
        <meta name="keywords" content="pimpinan PT Jagat Indo Perkasa, H. GT. Denny Ramdhani Director, Rano General Manager, manajemen ground handling Indonesia, direktur ground handling, kepemimpinan penerbangan, tim manajemen profesional" data-id="element-384" />
        <meta name="author" content="PT Jagat Indo Perkasa" data-id="element-385" />
        <meta name="robots" content="index, follow" data-id="element-386" />
        <link rel="canonical" href="https://jagatindoperkasa.id/leadership" data-id="element-387" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-388" />
        <meta property="og:url" content="https://jagatindoperkasa.id/leadership" data-id="element-389" />
        <meta property="og:site_name" content="PT Jagat Indo Perkasa" data-id="element-390" />
        <meta property="og:title" content="Pimpinan PT Jagat Indo Perkasa - Kepemimpinan Berpengalaman" data-id="element-391" />
        <meta property="og:description" content="Kepemimpinan yang berpengalaman dan berdedikasi dalam industri ground handling Indonesia. H. GT. Denny Ramdhani sebagai Director dan Rano sebagai General Manager." data-id="element-392" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/7qHA5xTLqzhhJbzjaRyUa8/HGT.png" data-id="element-393" />
        <meta property="og:locale" content="id_ID" data-id="element-394" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-395" />
        <meta name="twitter:url" content="https://jagatindoperkasa.id/leadership" data-id="element-396" />
        <meta name="twitter:title" content="Pimpinan PT Jagat Indo Perkasa" data-id="element-397" />
        <meta name="twitter:description" content="Kepemimpinan berpengalaman dalam industri ground handling Indonesia" data-id="element-398" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/7qHA5xTLqzhhJbzjaRyUa8/HGT.png" data-id="element-399" />
        {/* Structured Data */}
        <script type="application/ld+json" data-id="element-400">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'ProfilePage',
          '@id': 'https://jagatindoperkasa.id/leadership#profilepage',
          mainEntity: {
            '@type': 'Organization',
            '@id': 'https://jagatindoperkasa.id/#organization',
            employee: leaders.map(leader => ({
              '@type': 'Person',
              name: leader.name,
              jobTitle: leader.title,
              image: leader.image,
              worksFor: {
                '@type': 'Organization',
                name: 'PT Jagat Indo Perkasa'
              }
            }))
          }
        })}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-500 to-blue-700 text-white py-16" data-id="element-401">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-402">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-403">Pimpinan</h1>
          <p className="text-xl text-sky-100" data-id="element-404">
            Kepemimpinan yang berpengalaman dan berdedikasi
          </p>
        </div>
      </section>
      {/* Leadership Profiles */}
      <section className="py-16 bg-white" data-id="element-405">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-406">
          <div className="space-y-16" data-id="element-407">
            {leaders.map((leader, index) => <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl overflow-hidden" data-id="element-408">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8 md:p-12" data-id="element-409">
                  <div className="flex flex-col items-center md:items-start" data-id="element-410">
                    <div className="w-64 h-64 rounded-full overflow-hidden mb-6 shadow-lg" data-id="element-411">
                      <img src={leader.image} alt={leader.name} className="w-full h-full object-cover" data-id="element-412" />
                    </div>
                    <div className="text-center md:text-left" data-id="element-413">
                      <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-414">
                        {leader.name}
                      </h2>
                      <p className="text-xl text-sky-600 font-semibold mb-4" data-id="element-415">
                        {leader.title}
                      </p>
                      <div className="flex space-x-3 justify-center md:justify-start" data-id="element-416">
                        <a href="mailto:jagatindoperkasa1977@gmail.com" className="w-10 h-10 bg-sky-100 rounded-full flex items-center justify-center hover:bg-sky-200 transition-colors" data-id="element-417">
                          <MailIcon className="w-5 h-5 text-sky-600" data-id="element-418" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center" data-id="element-419">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-420">
                      Profil
                    </h3>
                    <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-421">
                      {leader.profile.map((paragraph, pIndex) => <p key={pIndex} data-id="element-422">{paragraph}</p>)}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Leadership Values */}
      <section className="py-16 bg-gray-50" data-id="element-423">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-424">
          <div className="text-center mb-12" data-id="element-425">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-426">
              Filosofi Kepemimpinan
            </h2>
            <p className="text-lg text-gray-600" data-id="element-427">
              Prinsip-prinsip yang memandu kepemimpinan kami
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-428">
            {[{
            title: 'Integritas',
            description: 'Menjunjung tinggi kejujuran dan transparansi dalam setiap keputusan bisnis'
          }, {
            title: 'Keunggulan',
            description: 'Berkomitmen untuk memberikan layanan terbaik dan terus meningkatkan standar'
          }, {
            title: 'Kolaborasi',
            description: 'Membangun kemitraan yang kuat dengan semua stakeholder untuk kesuksesan bersama'
          }].map((value, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-429">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-430">
                  {value.title}
                </h3>
                <p className="text-gray-600" data-id="element-431">{value.description}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}